var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile_image",on:{"click":_vm.onImage}},[_c('img',{attrs:{"src":_vm.imageSrc}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }